"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const scale_1 = require("../../utils/scale");
const DateTimeTooltip = ({ title, children, tooltipStyle }) => {
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const [isShow, setIsShow] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_native_1.View, { style: { position: 'relative' } },
        react_1.default.createElement(react_native_1.Pressable, { onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), onPress: () => {
                if (!isHovered)
                    setIsShow(!isShow);
            } },
            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.textTime, weight: "300" }, children)),
        (isHovered || isShow) && (react_1.default.createElement(CustomText_1.default, { style: [styles.textTimeNow, tooltipStyle], weight: "300", numberOfLines: 1 }, title))));
};
exports.default = DateTimeTooltip;
const styles = react_native_1.StyleSheet.create({
    textTime: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(15),
        color: '#7C7C7C',
    },
    textTimeNow: {
        fontSize: (0, scale_1.moderateScale)(9),
        lineHeight: (0, scale_1.moderateScale)(14),
        color: '#FEFEFE',
        backgroundColor: '#000000B2',
        paddingHorizontal: (0, scale_1.scale)(2),
        top: (0, scale_1.scale)(20),
        position: 'absolute',
        zIndex: 99,
        borderRadius: (0, scale_1.scale)(2),
        textAlign: 'center',
        maxWidth: 200,
    },
});
